import { IDiscounts, IOrderRow } from "@iloq/shared/";
import { calculateDiscountPrice } from "@/util/PriceUtil";

export const orderMixin = {
  methods: {
    campaignPrice(cartItem: IOrderRow, discounts?: IDiscounts): number | undefined {
      return calculateDiscountPrice(cartItem, discounts, false, true);
    },
  },
};

export const inputMixin = {
  methods: {
    inputIsInvalid(inputName: string, complete?: boolean): boolean {
      const name = complete ? inputName : `cart.deliveryDetails.${inputName}`;
      return (this as any).getFieldClasses(name)?.["is-invalid"] === true;
    },
  },
};
